/*
 * The customer app hosts the only login screen. This console has none of its
 * own: it sends people there with its own origin, and sign-in returns them
 * here. One session serves both, because the cookie is set on the API origin
 * that both call.
 *
 * There is no deriving this from the current host — the two are siblings in
 * production (admin.wundo.ai / app.wundo.ai) but not on stage
 * (admin.stage.wundo.ai / stage.wundo.ai), so it has to be configured.
 *
 * Missing it says so plainly: this is the only way in, and `new URL` with an
 * undefined base would otherwise fail at the click with nothing to point at.
 */
function appOrigin(): string {
  const appUrl: string | undefined = import.meta.env.VITE_APP_URL;

  if (!appUrl) {
    throw new Error(
      'VITE_APP_URL is not set, so there is no customer app to send you to. Set it to the customer app origin at build time.',
    );
  }

  return appUrl;
}

/**
 * Where sign-in happens. Absolute and on another origin, so the session guard
 * leaves this app entirely rather than trying to route to it.
 */
export function loginUrl(): string {
  return new URL('/login', appOrigin()).toString();
}

/*
 * Where someone belongs when they are signed in but this console is not theirs.
 * They have a home to go to, so send them there rather than showing a refusal —
 * for a customer, arriving here at all is a wrong turn, not a permission they
 * are missing.
 */
export function customerAppUrl(): string {
  return appOrigin();
}
